// removed by extract-text-webpack-plugin
module.exports = {"container":"floating-button-container__container__3Z-lq","link":"floating-button-container__link__37pYo","button-container":"floating-button-container__button-container__14ds-","AnimationButton":"floating-button-container__AnimationButton__3jeRg","close-button":"floating-button-container__close-button__bCWUz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/floating-button-container.scss
// module id = 1357
// module chunks = 1